import { Trans } from 'react-i18next'

export const getPricing = () => ({
  list: [
    <Trans i18nKey='addons.store.ip.domain.whitelisting.pricing.list.1' />,
    <Trans i18nKey='addons.store.ip.domain.whitelisting.pricing.list.2' />,
    <Trans i18nKey='addons.store.ip.domain.whitelisting.pricing.list.3' />
  ]
})
